import { render, staticRenderFns } from "./CLoader.vue?vue&type=template&id=44e1a877&scoped=true"
import script from "./CLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CLoader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CLoader.vue?vue&type=style&index=0&id=44e1a877&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e1a877",
  null
  
)

export default component.exports